import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { supabase } from '../../../supabaseClient';
import { useAuth } from '../../../hooks/useAuth';

export default function ProviderLoginPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const { sessionLoading, user } = useAuth();

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const from = (location.state as any)?.from?.pathname || '/provider/entry';

  if (!sessionLoading && user) {
    navigate('/provider/entry', { replace: true });
  }

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setSubmitting(true);
    setError(null);

    const { error } = await supabase.auth.signInWithPassword({
      email: email.trim(),
      password,
    });

    setSubmitting(false);

    if (error) {
      setError(error.message);
      return;
    }

    navigate(from, { replace: true });
  };

  const handleGoogleLogin = async () => {
    setSubmitting(true);
    setError(null);

    const { error } = await supabase.auth.signInWithOAuth({
      provider: 'google',
      options: {
        redirectTo: `${window.location.origin}/auth/callback`,
      },
    });

    setSubmitting(false);

    if (error) {
      setError(error.message);
    }
  };

  return (
    <div
      style={{
        minHeight: '100vh',
        background: '#f7f8fa',
        display: 'grid',
        placeItems: 'center',
        padding: '2rem 1rem',
      }}
    >
      <div
        style={{
          width: '100%',
          maxWidth: 520,
          background: '#ffffff',
          borderRadius: 20,
          padding: '2rem',
          boxShadow: '0 10px 30px rgba(15, 23, 42, 0.08)',
        }}
      >
        <p style={{ margin: 0, color: '#6b7280', fontSize: '0.95rem' }}>
          HnB provider portal
        </p>
        <h1 style={{ marginTop: '0.5rem', marginBottom: '0.75rem' }}>
          Provider login
        </h1>
        <p style={{ marginTop: 0, color: '#4b5563', lineHeight: 1.6 }}>
          Sign in as a provider owner to continue to onboarding or your provider dashboard.
        </p>

        <form onSubmit={handleSubmit} style={{ display: 'grid', gap: '1rem', marginTop: '1.5rem' }}>
          <label style={{ display: 'grid', gap: '0.4rem' }}>
            <span>Email</span>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              autoComplete="email"
              style={{
                padding: '0.9rem 1rem',
                borderRadius: 12,
                border: '1px solid #d1d5db',
                fontSize: '1rem',
              }}
            />
          </label>

          <label style={{ display: 'grid', gap: '0.4rem' }}>
            <span>Password</span>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              autoComplete="current-password"
              style={{
                padding: '0.9rem 1rem',
                borderRadius: 12,
                border: '1px solid #d1d5db',
                fontSize: '1rem',
              }}
            />
          </label>

          {error ? (
            <div
              style={{
                padding: '0.85rem 1rem',
                borderRadius: 12,
                background: '#fef2f2',
                color: '#991b1b',
                border: '1px solid #fecaca',
              }}
            >
              {error}
            </div>
          ) : null}

          <button
            type="submit"
            disabled={submitting}
            style={{
              padding: '0.95rem 1rem',
              borderRadius: 12,
              border: 'none',
              background: '#111827',
              color: '#ffffff',
              fontWeight: 600,
              cursor: 'pointer',
            }}
          >
            {submitting ? 'Signing in...' : 'Sign in'}
          </button>
        </form>

        <button
          type="button"
          onClick={handleGoogleLogin}
          disabled={submitting}
          style={{
            marginTop: '0.75rem',
            width: '100%',
            padding: '0.95rem 1rem',
            borderRadius: 12,
            border: '1px solid #d1d5db',
            background: '#ffffff',
            color: '#111827',
            fontWeight: 600,
            cursor: 'pointer',
          }}
        >
          Continue with Google
        </button>

        <div style={{ marginTop: '1.5rem', display: 'grid', gap: '0.75rem' }}>
          <Link to="/provider/signup">Create provider account</Link>
          <Link to="/forgot-password">Forgot password?</Link>
          <Link to="/login">Customer login</Link>
        </div>
      </div>
    </div>
  );
}